import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../api/axiosInstance';
// Async thunk for fetching address data
export const fetchAddress = createAsyncThunk('address/fetchAddress', async () => {
  const response = await axiosInstance.post(
    '/api/Common/GetWebsiteSettings',
    { websiteType: 2 },
    {
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
    }
  );
  return JSON.parse(response.data.message); // Parse the stringified JSON response
});

// Address slice
const addressSlice = createSlice({
  name: 'address',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// Selectors
export const selectAddress = (state) => state.address.data;
export const selectAddressLoading = (state) => state.address.loading;
export const selectAddressError = (state) => state.address.error;

export default addressSlice.reducer;
